import React from 'react'
import Styling from '../../styling'

export default function PillDefault(props) {
  const {
    children, 
    className, 
    color="neutral",
  } = props
  const _colors = `bg-${color}-700 text-white`
  return (
    <div 
      className={`${className} ${_colors} ${Styling.sizes.sm.strong} rounded-xl text-center px-2 inline-block`}
    >
      {children}
    </div>
  )
}
